<template>
  <div v-if="loaded" class="row">
    <!-- Réorganise ton formulaire ici -->
    <mh-input
      :readonly="courrier_type.ID.value !== ''"
      mhClass="col-6"
      field="nom"
      :table="courrier_type"
    ></mh-input>
    <b-col lg="6"></b-col>
    <mh-input
      mhClass="col-6"
      field="doSignature"
      :table="courrier_type"
    ></mh-input>
    <mh-input
      mhClass="col-6"
      field="doEntete"
      :table="courrier_type"
    ></mh-input>
    <mh-input
      mhClass="col-6"
      field="forNego"
      :table="courrier_type"
    ></mh-input>
    <mh-input
      mhClass="col-6"
      field="shortcut"
      :table="courrier_type"
    ></mh-input>
    <b-col lg="12">
    <hr/>

    </b-col>
    <b-col lg="6" class="mt-2">
      <b-card class="shadow bg-light">
        <h6>Français</h6>
        <label>Titre</label>
        <b-input v-model="courrier_type.trads.fr.titre.text"></b-input>
        <label class="mt-2">Référence</label>
        <b-input v-model="courrier_type.trads.fr.ref.text"></b-input>
        <label class="mt-2">Texte</label>
        <b-textarea
          rows="20"
          v-model="courrier_type.trads.fr.content.text"
        ></b-textarea>
      </b-card>
    </b-col>
    <b-col lg="6" class="mt-2">
      <b-card class="shadow bg-light">
        <h6>Néerlandais</h6>
        <label>Titre</label>
        <b-input v-model="courrier_type.trads.nl.titre.text"></b-input>
        <label class="mt-2">Référence</label>
        <b-input v-model="courrier_type.trads.nl.ref.text"></b-input>
        <label class="mt-2">Texte</label>
        <b-textarea
          rows="20"
          v-model="courrier_type.trads.nl.content.text"
        ></b-textarea>
      </b-card>
    </b-col>
    <b-col lg="6" class="mt-2">
      <b-card class="shadow bg-light">
        <h6>Anglais</h6>
        <label>Titre</label>
        <b-input v-model="courrier_type.trads.en.titre.text"></b-input>
        <label class="mt-2">Référence</label>
        <b-input v-model="courrier_type.trads.en.ref.text"></b-input>
        <label class="mt-2">Texte</label>
        <b-textarea
          rows="20"
          v-model="courrier_type.trads.en.content.text"
        ></b-textarea>
      </b-card>
    </b-col>
    <b-col lg="6" class="mt-2">
      <b-card class="shadow bg-light">
        <h6>Allemand</h6>
        <label>Titre</label>
        <b-input v-model="courrier_type.trads.de.titre.text"></b-input>
        <label class="mt-2">Référence</label>
        <b-input v-model="courrier_type.trads.de.ref.text"></b-input>
        <label class="mt-2">Texte</label>
        <b-textarea
          rows="20"
          v-model="courrier_type.trads.de.content.text"
        ></b-textarea>
      </b-card>
    </b-col>
    <b-col class="text-right mt-3">
      <b-button @click="$emit('close')">Annuler</b-button>
      <b-button
        :disabled="courrier_type.nom.value.trim().length == 0"
        @click="save"
        class="ml-3"
        >Enregistrer</b-button
      >
    </b-col>
  </div>
</template>

<script>
import courrier_types from "@/services/courrier_types";
import MhInput from "@/components/MhInput.vue";
export default {
  name: "CourrierType",
  components: {
    MhInput,
  },
  props: {
    courrier_type_id: [Number, String],
  },
  data() {
    return {
      courrier_type: {},
      loaded: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      courrier_types
        .courrier_type({
          courrier_type_id: this.courrier_type_id,
        })
        .then((response) => {
          this.courrier_type = response.data;
          this.loaded = true;
        });
    },

    save() {
      courrier_types
        .update_courrier_type({
          courrier_type_id: this.courrier_type_id,
          courrier_type: this.courrier_type,
        })
        .then((response) => {
          if (response.data.success) {
            this.$bvToast.toast("courrier_type mise à jour", {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "success",
              autoHideDelay: 2000,
              solid: false,
            });
            for (let el in this.courrier_type) {
              if (this.courrier_type[el]) {
                this.courrier_type[el].error = false;
              }
            }
            this.$emit("change");
            this.$emit("close");
          } else if (response.data.fail) {
            for (let el in this.courrier_type) {
              if (this.courrier_type[el]) {
                this.courrier_type[el].error = false;
              }
            }
            response.data.fail.forEach((element) => {
              this.courrier_type[element.field].error =
                element.errors.join(" ; ");
            });
          } else if (response.data.error) {
            this.$bvToast.toast("Erreur : " + response.data.error, {
              title: `Recuperator`,
              toaster: "b-toaster-top-right",
              variant: "danger",
              autoHideDelay: 2000,
              solid: false,
            });
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>